import {KeyboardDatePicker, KeyboardDatePickerProps} from '@material-ui/pickers';
import React from 'react';
import {InputProps} from '../../models/FormInputs';

type DatePickerProps = KeyboardDatePickerProps & InputProps;

export const QuoteDatePicker = (props: DatePickerProps) => {
  const {value, id, onChange, inputFieldProps, className, label, ...otherProps} = props;
  return (
    <KeyboardDatePicker
      id={id}
      InputProps={inputFieldProps}
      onChange={onChange}
      className={className}
      value={value}
      format={'MM/dd/yyyy'}
      placeholder="MM/DD/YYYY"
      variant="inline"
      margin="dense"
      inputVariant="outlined"
      fullWidth
      KeyboardButtonProps={{
        'aria-label': `change ${typeof label === 'string' ? label : 'date'}`,
      }}
      {...otherProps}
    />
  );
};
